import React from "react";

export function CreditScoreIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 57.97 35.61"
      width="30"
      height="30"
      fill="white"
      {...props}
    >
      <path
        className="cls-1"
        d="m53.02,35.61H4.95c-2.73,0-4.95-2.22-4.95-4.95V4.95C0,2.22,2.22,0,4.95,0h48.07c2.73,0,4.95,2.22,4.95,4.95v25.71c0,2.73-2.22,4.95-4.95,4.95ZM4.95,1.41c-1.95,0-3.53,1.59-3.53,3.53v25.71c0,1.95,1.59,3.53,3.53,3.53h48.07c1.95,0,3.53-1.59,3.53-3.53V4.95c0-1.95-1.59-3.53-3.53-3.53H4.95Z"
      />
      <rect className="cls-1" x=".71" y="7.28" width="56.56" height="7.89" />
      <rect className="cls-1" x="43.45" y="21.09" width="7.89" height="7.89" />
    </svg>
  );
}
